/**
 * REV-21869 (#165, AP8d) — ADR-0018 interim. The FE reads `/api/ai/abcp/runs` directly until the
 * REV-21378 projection replaces it (contract.md "Nahtstellen"); these mirror the response shapes
 * of `aumico-ms-ai-agents` (`types/lib/models/api/run.ts`, `types/lib/models/api/trail.ts`),
 * narrowed to the fields this client actually reads.
 */

/** `ClosingRunStatus` — `types/lib/models/api/run.ts`. */
export type AiAbcpRunStatus = 'RUNNING' | 'COMPLETED' | 'FAILED';

/**
 * One row of `GET /api/ai/abcp/runs` — `ClosingRunView`, narrowed. A run covers the accounts one
 * trigger touched, so an account's history is in the runs whose `accountIds` name it.
 */
export interface AiAbcpRunSummary {
    runId: string;
    status: AiAbcpRunStatus;
    accountIds: string[];
    startedAt: string;
}

/** `TrailEntryKind` — `types/lib/models/api/trail.ts`. */
export type AiAbcpTrailEntryKind = 'OK' | 'ATTENTION' | 'AI_FINDING';

/** One row of `GET /api/ai/abcp/runs/:runId/trail` — `RunTrailEntry`, narrowed. */
export interface AiAbcpTrailEntry {
    runId: string;
    sequence: number;
    at: string;
    accountId: string | null;
    documentId: string | null;
    /** `TrailStepKey`: `RUN_STARTED`, `DOCUMENT_READ`, `DOCUMENT_UNREADABLE`, `COMPARED`, `RUN_FAILED`. */
    step: string;
    kind: AiAbcpTrailEntryKind;
    titleKey: string;
    params: Record<string, string | number>;
}

/** `RunTrailPage` — `types/lib/models/api/trail.ts`. */
export interface AiAbcpTrailPage {
    runId: string;
    entries: AiAbcpTrailEntry[];
    nextSequence: number | null;
    total: number;
}
